export default "<input [(ngModel)]=\"linearZoom\" type=\"range\" [min]=\"minLinear\" [max]=\"maxLinear\" class=\"slider\">"